import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import SumsubWebSdk from "@sumsub/websdk-react";
import { fetchSumsubToken } from "../../../redux/actions/kyc-sumsub";
import { SumSubKYCSheckSkeleton } from "../../Skeleton";
import ErrorMessage from "../../Common/ErrorMessage";
import LoadingModal from "../../Modals/LoadingModal";
import { NavigationButton } from "../../Buttons";

const SumsubKYCCheck = ({
  handleNext,
  handlePrev,
  isSubAccount,
  subAccountClientId,
}) => {
  const [isLoading, setisLoading] = useState(false);
  const [isSuccess, setSuccess] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  // const [reviewAnswer, setReviewAnswer] = useState("");

  const [error, setError] = useState("");

  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");

  useEffect(() => {
    const handleThemeChange = () => {
      setTheme(localStorage.getItem("theme") || "light");
    };

    window.addEventListener("themeChanged", handleThemeChange);

    // Cleanup the event listener
    return () => {
      window.removeEventListener("themeChanged", handleThemeChange);
    };
  }, []);

  const dispatch = useDispatch();
  const [accessToken, setAccessToken] = useState(null);

  const fetchToken = async () => {
    try {
      const requestData = {};
      if (isSubAccount && subAccountClientId) {
        requestData.sub_client_id = subAccountClientId;
      }
      const response = await dispatch(fetchSumsubToken(requestData));

      if (response && response.token) {
        setError("");
        return response.token;
      } else {
        const errMsg =
          response?.message || "Failed to initialize verification token.";
        console.error("Failed to get token:", errMsg);
        setError(errMsg);
        return null;
      }
    } catch (err) {
      console.error("Token fetch exception:", err);
      setError(
        "An unexpected network error occurred while fetching the secure token.",
      );
      return null;
    }
  };

  useEffect(() => {
    fetchToken().then((token) => {
      if (token) setAccessToken(token);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const accessTokenExpirationHandler = async () => {
    return await fetchToken();
  };

  const messageHandler = (type, payload) => {
    console.log("WebSDK event:", type, payload);

    switch (type) {
      case "idCheck.onApplicantSubmitted":
        // 1. User has completed the form and submitted their documents.
        console.log("payload on onApplicantSubmitted", payload);

        // setIsVerified(true);
        // setError("");
        // setSuccess(true);
        // setIsModalOpen(true);

        // setTimeout(() => {
        //   setIsModalOpen(false);
        //   setSuccess(false);
        //   if (handleNext) handleNext();
        // }, 2000);
        break;

      case "idCheck.onApplicantStatusChanged":
        // payload.reviewResult.reviewAnswer === 'GREEN' (Approved)
        // payload.reviewResult.reviewAnswer === 'RED' (Rejected)
        const status = payload?.reviewStatus;
        console.log("status", status);

        if (status === "pending") {
          setIsVerified(true);
          //   setError("");
          //   setSuccess(true);
          //   setIsModalOpen(true);
        }
        // if (status === "completed" && answer === "GREEN") {
        //   setReviewAnswer("GREEN");
        //   setIsVerified(true);
        //   setError("");
        //   setSuccess(true);
        //   setIsModalOpen(true);
        // }
        console.log("payload on idCheck.onApplicantStatusChanged", payload);

        break;
      case "idCheck.onError":
        console.error("Sumsub WebSDK Error:", payload);
        setError(
          payload?.error || "A verification error occurred. Please try again.",
        );
        break;
      default:
        break;
    }
  };

  // Handles initialization errors (iframe failing to load entirely)
  const errorHandler = (err) => {
    console.error("WebSDK initialization error:", err);
    setError(
      "Failed to load the verification module. Please check your connection and try again.",
    );
  };

  if (!accessToken && !error) {
    return <SumSubKYCSheckSkeleton />;
  }

  return (
    <>
      <div className="w-full md:w-[800px] lg:w-[900px] mx-auto p-6 md:p-8 bg-background-surface border border-divider rounded-3xl shadow-sm custom-transition">
        {" "}
        {error && <ErrorMessage message={error} onClose={() => setError("")} />}
        <h1 className="text-text-primary text-2xl font-semibold text-center tracking-tight mb-2">
          Identity Verification
        </h1>
        <p className="text-text-secondary text-sm font-normal text-center mb-8">
          Please complete the secure KYC process below.
        </p>
        {accessToken && (
          <div className="mt-6">
            <SumsubWebSdk
              key={theme}
              accessToken={accessToken}
              expirationHandler={accessTokenExpirationHandler}
              config={{
                lang: "en",
                theme: theme,
              }}
              options={{
                adaptIframeHeight: true,
              }}
              onMessage={messageHandler}
              onError={errorHandler}
            />
          </div>
        )}
        <div className="flex justify-between mt-6">
          <NavigationButton onClick={handlePrev} text="Back" />
          {isVerified && (
            <NavigationButton onClick={handleNext} text="Confirm" />
          )}
        </div>
      </div>

      {/* Integrate the Loading/Success Modal */}
      <LoadingModal
        isLoading={isLoading}
        setisLoading={setisLoading}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        isSuccess={isSuccess}
        setSuccess={setSuccess}
        title="Verification Submitted!"
        description="Your documents have been securely submitted. Moving you to the next step..."
        redirectionAfterClose={() => {
          if (handleNext) handleNext();
        }}
      />
    </>
  );
};

export default SumsubKYCCheck;
